import FilterDCDDData from "./page/FilterDCDDData";

const DcddReport:React.FC = () =>{
    return(
        <>
          <FilterDCDDData/>
        </>
    )
};
export default DcddReport;